import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';

export const isPositionInBounds = (
  position: RelativeAbsolutePosition,
  bounds: [RelativeAbsolutePosition, RelativeAbsolutePosition],
) => {
  const [start, end] = bounds;

  return (
    position.relative.x >= start.relative.x &&
    position.relative.x <= end.relative.x
  );
};
